import {DateTimeFormatter} from "@js-joda/core";
import { Color, SymbolType } from "types/types";

export const DEFAULT_DATE_PATTERN = "yyyy-MM-dd HH:mm";
export const DEFAULT_DATE_TIME_PATTERN = "yyyy-MM-dd HH:mm:ss";
export const DEFAULT_DATE_FORMAT = "yy-mm-dd"

export const DEFAULT_DATE_FORMATTER = DateTimeFormatter.ofPattern(DEFAULT_DATE_PATTERN);
export const DEFAULT_DATE_TIME_FORMATTER = DateTimeFormatter.ofPattern(DEFAULT_DATE_TIME_PATTERN);

export const taskExecutorQueues = [
    {
        value: "DEFAULT",
        label: "Default"
    },
    {
        value: "FAST_COMPUTE",
        label: "Fast Compute"
    },
]

export const DEFAULT_DASHBOARD_URL = "/EASAS/views/dataservices/dataservicedashboard.xhtml?"

export const EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
export const CSV_TYPE = "text/csv;charset=utf-8,";

export const BAR_CHART_DATA_POINTS_LIMIT = 100;

export const EASAS_JS_SCRAPER_URL = () => {
    return process.env.EASASJS_VERSIONS_SCRAPER_URL!!;
};

export const EASAS_REST_URL = () => {
    return `${window.contextRoot}/rest`;
};

export const symbols: SymbolType[] = [
  {
    name: "Circle",
    char: "⬤",
    decCode: "&#11044;",
    plotlySymbol: "circle",
  },
  {
    name: "Diamond",
    char: "◆",
    decCode: "&#9670;",
    plotlySymbol: "diamond",
  },
  {
    name: "X",
    char: "🞬",
    decCode: "&#128940;",
    plotlySymbol: "x",
  },
  {
    name: "Triangle left",
    char: "◀",
    decCode: "&#9664;",
    plotlySymbol: "triangle-left",
  },
  {
    name: "Triangle right",
    char: "▶",
    decCode: "&#9654;",
    plotlySymbol: "triangle-right",
  },
  {
    name: "Star",
    char: "🟊",
    decCode: "&#128970;",
    plotlySymbol: "star",
  },
];

export const colors: Color[] = [
  {
    name: "Heat",
    hex: "#D95648",
  },
  {
    name: "PET",
    hex: "#E0C05B",
  },
  {
    name: "BMS",
    hex: "#2BBD66",
  },
  {
    name: "Air",
    hex: "#616BF2",
  },
  {
    name: "Dry",
    hex: "#E97451",
  },
  {
    name: "Boiler",
    hex: "#9ACD32",
  },
  {
    name: "Cold",
    hex: "#46BBC2",
  },
  {
    name: "Waste",
    hex: "#B358C9",
  },
  {
    name: "Blue-600",
    hex: "#003E79",
  },
  {
    name: "Blue-500",
    hex: "#005EB5",
  },
  {
    name: "Blue-400 primary",
    hex: "#007DF2",
  },
  {
    name: "Blue-300",
    hex: "#2997FF",
  },
  {
    name: "Blue-200",
    hex: "#5EB1FF",
  },
  {
    name: "Blue-100",
    hex: "#94CBFF",
  },
  {
    name: "Grey-700",
    hex: "#2E3A3C",
  },
  {
    name: "Grey-600",
    hex: "#5C7577",
  },
  {
    name: "Grey-500",
    hex: "#ABBCBE",
  },
  {
    name: "Grey-400 primary",
    hex: "#CED8D9",
  },
  {
    name: "Grey-300",
    hex: "#DAE2E3",
  },
  {
    name: "Grey-200",
    hex: "#E7EBEC",
  },
  {
    name: "Grey-100",
    hex: "#F3F5F6",
  },
];